import React from "react";
import { noteOptions } from "../../Constants/selections";
import UploadPanel from "../AddNoteModal/UploadPanel";
import "./index.css";

var getStringfromSeconds = function (time) {
  var t = new Date(parseInt(time));
  var tf = function (i) {
    return (i < 10 ? "0" : "") + i;
  };
  const yyyy = tf(t.getFullYear());
  const month = tf(t.getMonth() + 1);
  const mm = tf(t.getMinutes());
  const dd = tf(t.getDate());
  const hh = tf(t.getHours());
  const ss = tf(t.getSeconds());
  return dd + "/" + month + "/" + yyyy + " " + hh + ":" + mm + ":" + ss;
};
class NoteItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
      detail_visible: false,
    };
  }
  click = () => {
    const { detail_visible } = this.state;
    this.setState({ detail_visible: !detail_visible });
  };

  getNoteType = (noteType) => {
    const option = noteOptions.find((item) => item.value === noteType);
    return option ? option.label : noteOptions[0].label;
  };

  render() {
    const {
      note: { note, time, noter, noteType, uploads, address },
      isBrand,
      onClickAttachment,
    } = this.props;
    const { detail_visible } = this.state;
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <div
          className="note-item-container"
          onClick={this.click}
          style={{ background: "white" }}
        >
          <div className="note-item-details">
            <i className="fas fa-user" />
            <p>{isBrand ? noteType : this.getNoteType(noteType)}</p>
          </div>

          <p className="note-item-timestamp">{getStringfromSeconds(time)}</p>
        </div>
        {detail_visible && (
          <div className="note-content-container">
            {address && <p>{address}</p>}
            <p className="note-content">{note}</p>
            <p className="note-creator">By {noter}</p>
            {uploads && (
              <UploadPanel
                contents={uploads}
                readOnly={true}
                onClickAttachment={onClickAttachment}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}
export default NoteItem;



// WEBPACK FOOTER //
// ./src/components/NoteItem/index.js